import { createRoutine } from 'redux-saga-routines';

import { FullUser } from 'types';
import { CognitoError } from 'pages/Auth/utils';
import { CheckUserResponse } from 'services/auth';

export const doLogin = createRoutine('LOGIN', {
  trigger: (payload: {
    email: string;
    password: string;
    onFailure: (error: CognitoError) => void;
  }) => payload,
});

export const doLogout = createRoutine('LOGOUT');

export const doCheckIsAuthorized = createRoutine('CHECK_IS_AUTHORIZED', {
  trigger: (payload: {
    onSuccess?: (user: FullUser, session: any) => void;
    onFailure?: () => void;
  }) => payload,
});

export const doCheckUser = createRoutine('CHECK_USER', {
  trigger: (payload: {
    email: string;
    onSuccess: (data: CheckUserResponse) => void;
    onFailure: (error: any) => void;
  }) => payload,
});
